import angular from 'angular';

import component from './appVersionLabel.component';
import appVersionServiceModule from '../../service/AppVersionService';

let module = angular.module('recaps.components.appVersionLabel', [
  appVersionServiceModule.name,
]);

module.component('appVersionLabel', component);

export default module;
